import { Injectable} from "@angular/core";
import { Observable } from "rxjs";
import { ShellService } from '@mynexus/mfe-core';
import { HttpClient } from '@angular/common/http';
import { ProductNames } from "@mynexus/mynexus-ui-lib";
import { CarePathwayAssignedType, ReferenceByEntity, TissueType } from "../model/reference-by-entity.model";
import { EMPTY_GUID } from "../constants";

@Injectable({
    providedIn: 'root'
})
export class ReferenceByEntityService {
  constructor(
    private readonly http: HttpClient,
    private readonly shellService : ShellService
  ) {
  }

  getDropdownValues(tenantId: string, entity: string, reference: string): Observable<ReferenceByEntity[]> {
    const baseUrl = this.shellService.getBaseUrlFor(ProductNames.HomeHealth);
    const url = `${baseUrl}/ReferenceByEntity/GetDropdownValues/${tenantId}/${entity}/${reference}`;
    return this.http.get<ReferenceByEntity[]>(url);
  }

  getReferenceByEntity(tenantId: string, entity: string): Observable<ReferenceByEntity[]> {
    const baseUrl = this.shellService.getBaseUrlFor(ProductNames.HomeHealth);
    const url = `${baseUrl}/ReferenceByEntity/GetReferenceByEntity/${tenantId}/${entity}`;
    return this.http.get<ReferenceByEntity[]>(url);
  }

  getReferenceByEntityValue(doc: any, fieldName: string): ReferenceByEntity {
    const value = doc[fieldName];
    if(value === null || value?.length === 0) return undefined;
    return {
      ...this.entityObject,
      referenceByEntityId: value,
    }
  }

  getReferenceByEntityArray(doc: any, fieldName: string, docId: string): TissueType[] & CarePathwayAssignedType[] {
    const refByEntityIds = doc[fieldName];
    if(refByEntityIds === null || refByEntityIds?.length === 0) return undefined;
    const result = [];
    refByEntityIds.forEach((id: string) => result.push({
      ...this.entityObject,
      referenceByEntityId: id,
      tissueTypeReferenceByEntityId: EMPTY_GUID,
      carePathwayAssignedReferenceByEntityId: EMPTY_GUID,
      woundDocumentationId: docId,
      isActive: false,
    }));
    return result;
  }

  private entityObject: ReferenceByEntity = {
    referenceByEntityId: '',
    entity: '',
    reference: '',
    description: '',
    applicationKey: '',
    sortOrder: 0,
    additionalValue: '',
    isActive: false,
  };
}
